import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('invoice_search')
        .setAdditionalRoutes(['invoice']),
    MenuEntry.create()
        .setRoute('credit_note_search')
        .setAdditionalRoutes(['credit_note']),
    MenuEntry.create()
        .setRoute('delivery_note_search')
        .setAdditionalRoutes(['delivery_note']),
    MenuEntry.create()
        .setRoute('incoming_credit_note_search')
        .setAdditionalRoutes(['incoming_credit_note']),
    MenuEntry.create()
        .setRoute('incoming_credit_note_list')
        .setAdditionalRoutes(['incoming_credit_note']),
    MenuEntry.create()
        .setRoute('quote_list')
        .setAdditionalRoutes(['quote']),
    MenuEntry.create()
        .setRoute('open_invoice_list'),
];
